module.exports = __webpack_public_path__ + "1061a19b0ca5be5000d30ddad7ddec3a.mov";